// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

export const ENDPOINT = 'api/'



// WEBPACK FOOTER //
// ./src/shared/constants.js